import { Resources } from "../ui/resources";

export interface CalculatorState {
  allActionsWithLargePayload: string[];
  calculateButtonText: string;
  errorMessage: string;
  repeatingActions: string[];
  repeatingActionsIterations: Record<string, number>;
  hasLargeActions: boolean;
  isCalculateClicked: boolean;
  isSelectAllActionsWithLargePayloadChecked: boolean;
  monthlyRuns: number;
  operationCountData: OperationCountData;
  workflowActions: string[];
  workflowDefinition: string;
}

export interface OperationCountData {
  blobReadBestGuess: number;
  blobReadMin: number;
  blobReadMax: number;
  blobWriteBestGuess: number;
  blobWriteMin: number;
  blobWriteMax: number;
  queueBestGuess: number;
  queueMin: number;
  queueMax: number;
  tableBestGuess: number;
  tableMin: number;
  tableMax: number;
}

export const initialState: CalculatorState = {
  allActionsWithLargePayload: [],
  calculateButtonText: Resources.CALCULATE_BUTTON_TEXT,
  errorMessage: '',
  repeatingActions: [],
  repeatingActionsIterations: {},
  hasLargeActions: false,
  isCalculateClicked: false,
  isSelectAllActionsWithLargePayloadChecked: false,
  monthlyRuns: 1,
  operationCountData: {
    blobReadBestGuess: 0,
    blobReadMin: 0,
    blobReadMax: 0,
    blobWriteBestGuess: 0,
    blobWriteMin: 0,
    blobWriteMax: 0,
    queueBestGuess: 0,
    queueMin: 0,
    queueMax: 0,
    tableBestGuess: 0,
    tableMin: 0,
    tableMax: 0
  },
  workflowActions: [],
  workflowDefinition: ''
};

export default initialState;